export default {
    computed: {

        subTotal() {
            if (this.tickets.length < 1) return "";

            let sum = this._.sumBy(this.tickets, o => o.price);
            return (Math.round(sum * 100) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').toString();
        },
        totalVat() {
            if (this.tickets.length < 1) return "";

            let sum = this._.sumBy(this.tickets, o => (o.price * o.vatRate) / 100);
            return (Math.round(sum * 100) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').toString();
        },
        totalPrice() {
            if (this.tickets.length < 1) return "";

            let sum = this._.sumBy(
                this.tickets,
                o => o.price + (o.price * o.vatRate) / 100
            );
            return (Math.round(sum * 100) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').toString() + " €";
        },
    }
};